import {
  FormField,
  type FormFieldProps,
  MultiSelectCombobox,
  type MultiSelectComboboxProps,
  Tag,
} from '@moia-dev/pace-web'
import { useId } from 'react'

export type MultiSelectComboFieldProps<Value> = Omit<
  FormFieldProps,
  'children'
> &
  Omit<MultiSelectComboboxProps<Value>, 'id'> & {
    id?: string
    tagSize?: 'default' | 'large'
  }

export const MultiSelectComboField = <Value,>({
  label,
  name,
  caption,
  id: maybeId,
  validation,
  required,
  maxLength,
  value,
  closeOnSelect,
  tagSize,
  ...props
}: MultiSelectComboFieldProps<Value>) => {
  const generatedId = useId()
  const id = maybeId ? maybeId : generatedId

  const handleTagDelete = (option: Value) => {
    props.onChange(props.values?.filter(item => item !== option) || [])
  }

  const values = props.values || []

  return (
    <div>
      <FormField
        value={value}
        required={required}
        maxLength={maxLength}
        caption={caption}
        label={label}
        htmlFor={id}
        validation={validation}
      >
        <MultiSelectCombobox {...props} id={id} closeOnSelect={closeOnSelect} />
      </FormField>
      {values.length > 0 && (
        <div
          css={theme => ({
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: theme.spacing(1),
            gap: theme.spacing(1),
          })}
        >
          {values.map(option => (
            <Tag
              size={tagSize ?? 'default'}
              key={`${props.optionToId?.(option) ?? option}-tag`}
              label={
                props.renderOption ? props.renderOption(option) : `${option}`
              }
              onDelete={
                props.disabled ? undefined : () => handleTagDelete(option)
              }
            />
          ))}
        </div>
      )}
    </div>
  )
}
